<div id="edit-user-documents" uk-modal>
    <div class="uk-modal-dialog">
        <a class="uk-modal-close-default">
            <img src="../../../../assets/icons/Close.svg" height="32px" width="32px">
        </a>
        <div class="uk-modal-body">
            <title class="uk-modal-title color-grey">Modifier les documents</title>
            <div class="uk-display-inline-block research-form-controls uk-width-1-1 uk-margin-remove">
                <h2 class="bold color-grey uk-text-uppercase">Modifier les documents</h2>
                <div uk-grid class="remove-grid-ml-pl uk-grid-small uk-margin-bottom">
                    <div class="uk-width-12-12">
                        <div class="uk-margin">
                            <label class="label">
                                Permis de conduire (recto)
                                <span *ngIf="drivingRecto && drivingRecto.name !== null" (click)="cancelPhoto(1)" style="font-size: 13px; margin-top: 4px;" 
                                class="color-dark-gray uk-text-uppercase uk-float-right pointer">Annuler</span>
                            </label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(1)" type="button">
                                    <span *ngIf="drivingRecto === null">Ajouter une photo</span>
                                    <span *ngIf="drivingRecto && drivingRecto.name !== null">{{ drivingRecto.name }}</span>
                                </button>
                            </div>
                        </div>
                        <div class="uk-margin">
                            <label class="label">
                                Permis de conduire (verso)
                                <span *ngIf="drivingVerso && drivingVerso.name !== null" (click)="cancelPhoto(2)" style="font-size: 13px; margin-top: 4px;" 
                                class="color-dark-gray uk-text-uppercase uk-float-right pointer">Annuler</span>
                            </label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(2)" type="button">
                                    <span *ngIf="drivingVerso === null">Ajouter une photo</span>
                                    <span *ngIf="drivingVerso && drivingVerso.name !== null">{{ drivingVerso.name }}</span>
                                </button>
                            </div>
                        </div>
                        <div class="uk-margin">
                            <label class="label">
                                Justificatif d'identité (recto)
                                <span *ngIf="idRecto && idRecto.name !== null" (click)="cancelPhoto(3)" style="font-size: 13px; margin-top: 4px;" 
                                class="color-dark-gray uk-text-uppercase uk-float-right pointer">Annuler</span>
                            </label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(3)" type="button">
                                    <span *ngIf="idRecto === null">Ajouter une photo</span>
                                    <span *ngIf="idRecto && idRecto.name !== null">{{ idRecto.name }}</span>
                                </button>
                            </div>
                        </div>
                        <div class="uk-margin">
                            <label class="label">
                                Justificatif d'identité (verso)
                                <span *ngIf="idVerso && idVerso.name !== null" (click)="cancelPhoto(4)" style="font-size: 13px; margin-top: 4px;" 
                                class="color-dark-gray uk-text-uppercase uk-float-right pointer">Annuler</span>
                            </label>
                            <div class="uk-form-controls uk-margin-small-top">
                                <button class="uk-width-1-1 round-button bigger" (click)="modifyPhoto(4)" type="button">
                                    <span *ngIf="idVerso === null">Ajouter une photo</span>
                                    <span *ngIf="idVerso && idVerso.name !== null">{{ idVerso.name }}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="uk-modal-footer">
            <p class="uk-text-right">
                <button class="button bold uk-modal-close" type="button">Annuler</button>
                <button class="button bold uk-margin-small-left" type="button" (click)="updateDocuments()">
                    Modifier
                </button>
            </p>
        </div>
    </div>
</div>